import { render } from "./MyOrders.vue?vue&type=template&id=4fc42334&scoped=true"
import script from "./MyOrders.vue?vue&type=script&lang=js"
export * from "./MyOrders.vue?vue&type=script&lang=js"

import "./MyOrders.vue?vue&type=style&index=0&id=4fc42334&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc42334"]])

export default __exports__